import commonJsModule from "pkg-banner-webpack-plugin"

export default commonJsModule.default